import { CallIntelligenceWetags } from '@wetags/call-intelligence';
import { Batch1ReadyBanner, FullyCompleteBanner, RecordingsDisabledBanner } from './trial-banners';

export const TrialGlobalBanners = () => {
  const [isTrialBackfillEnabled, isWetagLoading] = CallIntelligenceWetags.useWetag('call-intel-trial-backfill');

  if (isWetagLoading || !isTrialBackfillEnabled) return null;

  return (
    <>
      <Batch1ReadyBanner />
      <FullyCompleteBanner />
      <RecordingsDisabledBanner />
    </>
  );
};
